<template>
	<section>
		<!-- Row -->
		<div class="left_column" v-show="registryShown || !isMobile">

			<div class="left-column__sub-column">
				<date-picker monday-first v-model="day" :inline="true" language="ru" @selected="updateDay"
										 :calendar-class="'calendar'"></date-picker>

				<div class="daycounts">
					<span class="personal_items_wrap">Выберите количество дней

						<select title="select count of days" class="pointer" v-model="dayCount" @change="changeDayCount">
							<option value="1">1</option>
							<option value="3">3</option>
							<option value="5">5</option>
							<option value="7">7</option>
						</select>
					</span>
				</div>

				<div class="news">
					<p>Список врачей</p>
				</div>
			</div>

			<div class="left-column__sub-column left-column__sub-column_list" v-bind:style="{height: listHeight}">
				<div class="container_personal" v-for="item in personal">

					<div class="personal_row" @click="getDoctor(item._id)">

						<user-avatar :data="item.user" :set-class="'person_list_avatar'"></user-avatar>

						<div class="personal_list_short">
							<div class="personal_name">
								{{item.user.last_name}} {{item.user.first_name | one}} {{item.user.middle_name | one}}
							</div>

							<p class="med_center_descr">
								<span v-for="sp in item.specializations">{{sp.name}} </span>
								<span v-if="item.specializations && !item.specializations.length">Беспартийный</span>
							</p>

							<p class="med_center_descr mw-232" v-if="item.position && item.position.length > 0">{{item.position}}</p>

						</div>
					</div>
				</div>
			</div>

			<div class="news" v-show="inquiry.length">
				<p>Список заявок</p>
			</div>

			<div class="container_personal">
				<div v-for="item in inquiry">
					<div class="personal_items_wrap">
						<div class="hover-bg personal_row" @click="showInquiry(item)">

							<user-avatar :data="item.user" :set-class="'person_list_avatar pic_event pic_event1 cover'"></user-avatar>

							<div class="personal_list_short">
								<div class="personal_name">
									Клиент: {{item.user.last_name}} {{item.user.first_name | one}} {{item.user.middle_name | one}}
									<!--Доктор: {{item.worker.last_name}} {{item.worker.first_name | one}} {{item.worker.middle_name | one}}-->
								</div>
							</div>

						</div>
					</div>
				</div>
			</div>

		</div>

		<div class="right_column" v-bind:style="{height: leftColumnHeight}">
			<large-scheduler :isDoctor="true"></large-scheduler>
		</div>

	</section>
</template>

<script>
	import moment from 'moment';
	import DatePicker from 'vuejs-datepicker';
	import Role from '@/common/Role';

	export default {
		name: 'Registry',
		components: { DatePicker },
		computed: {
			monthName() {
				return moment(this.firstDayOfWeek, 'DD-MM-YYYY').format('MMM');
			},
			userId() {
				return this.$route.params.id;
			},
			doctorId() {
				return this.$route.query.id || undefined;
			},
			startDay() {
				return this.$route.query.start_day;
			},
			clinicId() {
				return this.$route.params.clinic;
			},
			Role() {
				if (this.$store.state.auth.user._id && this.$store.state.auth.worker._id && this.$store.state.auth.clinic._id) {
					return new Role(this.$store.state.auth.user, this.$store.state.auth.worker, this.$store.state.auth.clinic);
				}
			},
			isMobile() {
				return window.innerWidth < 768;
			},
		},
		mounted() {
			this.$event.connect('updateInquiryList', (doctorId) => {
				this.getInquiry(doctorId);
			});

			this.$event.connect('toggleRegistryMenu', () => {
				this.registryShown = !this.registryShown;
			});


			if (this.isMobile) {
				this.$event.send('updateDayCount', 1);
			} else {
				this.$event.send('updateDayCount', this.dayCount);
			}

			if (this.Role.isAdmin || this.Role.isRegistry) {
				this.getStaffs(this.clinicId);
				if (this.doctorId) {
					this.getDoctor(this.doctorId);
				} else {
					this.getDoctor(this.userId);
				}
			} else {
				this.getWorker(this.userId);
				this.getDoctor(this.userId);
			}

			this.checkStartDay(this.startDay);

			this.$nextTick(function () {
				this.getLeftColumnHeight();
				window.addEventListener('resize', this.getLeftColumnHeight);
			});
		},
		data() {
			return {
				dayCount: 7,
				day: moment().format(),
				personal: [],
				inquiry: [],
				dateValue: moment().format('DD-MM-YYYY'),
				isShowSettings: true,
				leftColumnHeight: 0,
				listHeight: 0,
				registryShown: false,
			};
		},
		methods: {
			getStaffs(id) {
				this.$store.dispatch('worker/list', { clinic_id: id, per_page: 100 })
					.then(list => list.data.filter(worker => +worker.blocked !== 1))
					.then(list => list.filter(worker => (
						worker.role_type === 'doctor'
						|| worker.role_type === 'doctor_admin'
						|| worker.role_type === 'doctor_registrar'
					)))
					.then(list => this.personal = list.sort(this.sortByPosition))
					.then(this.setListCellHeight)
					.then(this.getLeftColumnHeight); // this is needed for right column height
			},
			getWorker(id) {
				this.$store.dispatch('worker/get', id).then(worker => this.personal = [worker]);
			},
			getInquiry(id) {
				this.$store.dispatch('inquiry/list', {
					worker_id: id,
					clinic_id: this.clinicId,
				}).then(list => {
					this.inquiry = list;
				});
			},
			getDoctor(id) {
				this.$event.send('updateEvents', id);
				this.getInquiry(id);
			},
			showInquiry(item) {
				this.$event.send('openInquiryModal', item);
			},
			getDateAndTime(day, time, doctor) {
				this.openEditModal({
					begin: moment(day + ' ' + time, 'DD-MM-YYYY HH:mm').format('X'),
				}, doctor);
			},
			openEditModal(event, doctor) {
				this.$event.send('openEditModal', event, doctor);
			},
			openDetailsModal(visit) {
				this.$event.send('openDetailsModal', visit);
			},
			openStatusModal(visit) {
				this.$event.send('openStatusModal', visit);
			},
			changeDayCount() {
				this.$event.send('updateDayCount', this.dayCount);
			},
			goToAgenda(id) {
				this.$router.push({
					path: 'agenda',
					query: { doctor: id },
				});
			},
			updateDay(day) {
				this.$event.send('updateDayOfCalendar', day);
			},
			getLeftColumnHeight() {
				const $column = this.$el.getElementsByClassName('left_column')[0];
				this.leftColumnHeight = window.innerWidth > 991 ? $column.offsetHeight + 'px' : '100vmin';
			},
			setListCellHeight() {
				const $col = this.$el.getElementsByClassName('left_column')[0];
				const $list = this.$el.getElementsByClassName('left-column__sub-column_list')[0];
				const windowHeight = window.innerHeight;
				const listHeight = windowHeight - $list.offsetTop - 15 - 24;
				this.listHeight = listHeight + 'px';
			},
			sortByPosition(a, b) {
				const first = a.position && a.position.toLowerCase();
				const second = b.position && b.position.toLowerCase();
				if (first > second) {
					return 1;
				} else if (first < second) {
					return -1;
				}
				return 0;
			},

			checkStartDay(date) {
				if (date) {
					this.updateDay(moment(date, 'X').toDate());
				}
			},
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.getLeftColumnHeight);
			this.$event.disconnect(['toggleRegistryMenu', 'updateInquiryList']);
		},
	};

</script>

<style>
	.left-column__sub-column .vdp-datepicker__calendar .cell {
		height: 24px;
		line-height: 24px;
	}
    .mw-232 {
        max-width: 228px;
    }
</style>

<style scoped>

	.left_column {
		padding: 15px;
	}

	.left-column__sub-column_list {
		overflow: auto;
	}

	.right_column {
		padding: 15px;
		height: 100vmin;
		min-height: 80vmin;
	}

	.daycounts {
		margin: 8px;
	}

	.daycounts select {
		width: 50px;
	}

	.container_personal {
		display: block;
		cursor: pointer;
		margin: 8px 0;
		line-height: 1;
	}

	.person_list_avatar {
		width: 50px;
		height: 50px;
	}

	.personal_row > * {
		display: inline-block;
		white-space: nowrap;
		overflow-x: hidden;
	}

	.person_list_avatar {
		width: 32px;
		height: 32px;
		overflow: hidden;
		vertical-align: top;
		margin-right: 15px;
	}

	.calendar {
		width: 280px;
	}

	@media (min-width: 992px) {
		.left_column {
			float: left;
			width: 330px;
			display: flex;
			flex-direction: column;
			max-height: calc(100vh - 128px);
		}

		.right_column {
			float: right;
			width: calc(100% - 330px);
		}
		
	}

	@media (min-width: 630px) and (max-width: 991px) {
		.left_column:after {
			display: table;
			clear: both;
			content: '';
		}

		.left-column__sub-column {
			float: left;
		}

		.left-column__sub-column:not(:first-child) {
			margin-left: 15px;
		}
	}
</style>



// WEBPACK FOOTER //
// Registry.vue?a851fb82